import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/fontawesome/darkest/regular/spinner.svg")